import { PerformanceMetricBaseColumn } from './performance-metric-base-column';

/**
 * AuctionWonPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAuctionWonPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_IS' }) {
    super({
      name: 'AuctionWonPercent',
      format: 'percentage-value',
      helpId,
      i18n,
    });
  }
}

/**
 * AuctionLostToBudgetPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAuctionLostToBudgetPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ISBudget' }) {
    super({
      name: 'AuctionLostToBudgetPercent',
      format: 'percentage-value',
      helpId,
      i18n,
    });
  }
}

/**
 * AuctionLostToRankPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAuctionLostToRankPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ISRank' }) {
    super({
      name: 'AuctionLostToRankPercent',
      format: 'percentage-value',
      helpId,
      i18n,
    });
  }
}

/**
 * AuctionLostToAdQualityPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAuctionLostToAdQualityPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ISctr' }) {
    super({
      name: 'AuctionLostToAdQualityPercent',
      format: 'percentage-value',
      helpId,
      i18n,
    });
  }
}

/**
 * AuctionLostToLandingPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAuctionLostToLandingPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ISRelv' }) {
    super({
      name: 'AuctionLostToLandingPercent',
      format: 'percentage-value',
      helpId,
      i18n,
    });
  }
}

/**
 * AuctionLostToBidPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAuctionLostToBidPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ISBid' }) {
    super({
      name: 'AuctionLostToBidPercent',
      format: 'percentage-value',
      helpId,
      i18n,
    });
  }
}

export class ColumnExactMatchImpressionSharePercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'ExactMatchImpressionSharePercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_ExactMatchImpressionShare',
    });
  }
}

export class ColumnTopImpressionSharePercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'TopImpressionSharePercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_TopImpressionShare',
    });
  }
}

export class ColumnTopImpressionShareLostToBudget extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'TopImpressionShareLostToBudget',
      property: 'PerformanceMetrics/TopISLostToBudgetPercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_TopImpressionLosttoBudget',
    });
  }
}

export class ColumnTopImpressionShareLostToRank extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'TopImpressionShareLostToRank',
      property: 'PerformanceMetrics/TopISLostToRankPercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_TopImpressionLosttoRank',
    });
  }
}

export class ColumnAbsoluteTopImpressionSharePercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AbsoluteTopImpressionSharePercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_ProductAds_AbsoluteTopImpShare',
    });
  }
}

export class ColumnAbsoluteTopImpressionShareLostToBudget extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AbsoluteTopImpressionShareLostToBudget',
      property: 'PerformanceMetrics/AbsoluteTopISLostToBudgetPercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoBudget',
    });
  }
}

export class ColumnAbsoluteTopImpressionShareLostToRank extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AbsoluteTopImpressionShareLostToRank',
      property: 'PerformanceMetrics/AbsoluteTopISLostToRankPercent',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoRank',
    });
  }
}

/**
 * ClickSharePercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnClickSharePercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'ClickSharePercent',
      format: 'percentage-value',
      helpId: 'pop_BA_Reporting_ProductAds_ClickSharePercent',
      i18n,
    });
  }
}

/**
 * AudienceAuctionWonPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAudienceAuctionWonPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AudienceImpressionShare',
      property: 'PerformanceMetrics/AudienceAuctionWonPercent',
      format: 'percentage-value',
      helpId: 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare',
      i18n,
    });
  }

  template({ value }) {
    // eslint-disable-next-line no-extra-boolean-cast
    return super.template({ value: Boolean(value) ? value : null });
  }
}

/**
 * AudienceTopISLostToBudgetPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAudienceTopISLostToBudgetPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AudienceImpressionShareLostToBudget',
      property: 'PerformanceMetrics/AudienceTopISLostToBudgetPercent',
      format: 'percentage-value',
      helpId: 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare_LostBudget',
      i18n,
    });
  }

  template({ value }) {
    // eslint-disable-next-line no-extra-boolean-cast
    return super.template({ value: Boolean(value) ? value : null });
  }
}

/**
 * AudienceTopISLostToRankPercent
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAudienceTopISLostToRankPercent extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AudienceImpressionShareLostToRank',
      property: 'PerformanceMetrics/AudienceTopISLostToRankPercent',
      format: 'percentage-value',
      helpId: 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare_LostRank',
      i18n,
    });
  }

  template({ value }) {
    // eslint-disable-next-line no-extra-boolean-cast
    return super.template({ value: Boolean(value) ? value : null });
  }
}

/**
 * RelativeCTR
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnRelativeCTR extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'RelativeCTR',
      format: 'percentage-value',
      helpId: 'pop_BA_Reporting_Clarity_RelativeCTR',
      i18n,
    });
  }

  template({ value }) {
    // eslint-disable-next-line no-extra-boolean-cast
    return super.template({ value: Boolean(value) ? value : null });
  }
}

/**
 * All competitive columns
 * @type Class[]
 */
export const competitiveColumns = [
  ColumnAuctionWonPercent,
  ColumnAuctionLostToBudgetPercent,
  ColumnAuctionLostToRankPercent,
  ColumnAuctionLostToAdQualityPercent,
  ColumnAuctionLostToLandingPercent,
  ColumnAuctionLostToBidPercent,
  ColumnClickSharePercent,
];
